import {
  approvalPolicyOptionsQuery,
  workspaceApprovalPoliciesQuery,
} from "@common/api/approval-policies"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { requirePermission } from "@/lib/require-permission"
import { emptyPolicy } from "./-components/form/schema"
import { PolicyPage } from "./-components/policy-page"
import { SUBJECTS } from "./-lib/approvals"
import { subjectReference } from "./-lib/options"
import { CREATE_FLOWS_PERMISSION } from "./-lib/permission"

const searchSchema = z.object({
  subject: z.enum(SUBJECTS).optional().catch(undefined),
})

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/approval-flows/create",
)({
  staticData: { breadcrumb: "New flow" },
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      CREATE_FLOWS_PERMISSION,
      "/settings/workspace/general",
    ),
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(workspaceApprovalPoliciesQuery()),
      queryClient.ensureQueryData(approvalPolicyOptionsQuery()),
    ]),
  component: CreatePolicyPage,
})

function CreatePolicyPage(): React.ReactElement {
  const { subject } = Route.useSearch()
  const { data: options } = useSuspenseQuery(approvalPolicyOptionsQuery())

  return (
    <PolicyPage
      key={subject}
      policy={undefined}
      defaults={emptyPolicy(subjectReference(options, subject ?? null))}
    />
  )
}
